import { render, staticRenderFns } from "./GpsDrawerNavixy.vue?vue&type=template&id=5afb9ff6&"
import script from "./GpsDrawerNavixy.vue?vue&type=script&lang=js&"
export * from "./GpsDrawerNavixy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports